import BlockMoveDialog from './blockMoveDialog'
export default BlockMoveDialog
